// extracted by mini-css-extract-plugin
export default {"footer":"page-footer_footer__cZAs8"};